import axios from "axios";

import myConfig from "../configs/config";

function authHeaders() {
  return {
    Authorization: `Bearer ${localStorage.getItem("client-token")}`,
  };
}

function readSyncRevision(data) {
  if (!data || data.syncRevision == null) {
    return 0;
  }
  return data.syncRevision;
}

function readPublishedAt(data) {
  if (!data) {
    return null;
  }
  return data.publishedAt || null;
}

export async function fetchFarmMapSyncStatus(farmId) {
  const response = await axios.get(
    `${myConfig.API_URL}/farm/${farmId}/farm-map-sync/`,
    { headers: authHeaders() }
  );
  return {
    syncRevision: readSyncRevision(response.data),
    publishedAt: readPublishedAt(response.data),
  };
}

export async function publishFarmMapSync(farmId) {
  const response = await axios.put(
    `${myConfig.API_URL}/farm/${farmId}/farm-map-sync/`,
    {},
    { headers: authHeaders() }
  );
  return {
    syncRevision: readSyncRevision(response.data),
    publishedAt: readPublishedAt(response.data),
    detail: (response.data && response.data.detail) || "",
  };
}
